export default "__VITE_ASSET__AWjiq8zV__"